<template>
    <loading v-model:active="isLoading" :can-cancel="false" :on-cancel="onCancel" :is-full-page="fullPage" />
    <div class="container-fluid">
        <nav aria-label="breadcrumb">
            <ol class="breadcrumb">
                <li class="breadcrumb-item"><router-link to="/lead">Leads</router-link></li>
                <li class="breadcrumb-item active" aria-current="page">Novo lead</li>
            </ol>
        </nav>
        <div class="row" v-if="enable_error_list">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="alert alert-danger">
                    <ol>
                        <li v-for="(error, index) in errors" :key="index">{{ error[0] }}</li>
                    </ol>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-xl-12 col-md-12 col-sm-12">
                <div class="card shadow mb-4">
                    <!-- Card Header - Dropdown -->
                    <div class="card-body">
                        <form @submit="save">
                            <div class="row mt-3">
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">CPF / CNPJ</label>
                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: xx.xxx.xxx/xxxx-xx"
                                            v-model="lead.document" v-mask="['###.###.###-##', '##.###.###/####-##']">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" id="button-addon2"
                                                @click="searchCNPJ()"><i class="fa fa-search"></i>Buscar
                                                CNPJ</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="col-xl-8 col-md-8 col-sm-12">
                                    <label for="">Nome*</label>
                                    <input type="text" class="form-control" placeholder="Ex: Empresa XYZ"
                                        v-model="lead.name">
                                </div>
                            </div>
                            <div class="row mt-3">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">E-mail</label>
                                    <input type="text" class="form-control" placeholder="Ex: usurio@dominio.com"
                                        v-model="lead.email">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Telefone*</label>
                                    <input type="text" class="form-control" v-model="lead.phone"
                                        v-mask="['(##) ####-####', '(##) #####-####']" placeholder="(xx)x.xxxx-xxxx">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">CEP</label>

                                    <div class="input-group mb-3">
                                        <input type="text" class="form-control" placeholder="Ex: xxxxx-xxx"
                                            v-model="lead.zipcode" v-mask="['#####-###']">
                                        <div class="input-group-append">
                                            <button class="btn btn-success" type="button" id="button-addon2"
                                                @click="searchZipcode()"><i class="fa fa-search"></i>Buscar
                                                CEP</button>
                                        </div>

                                    </div>
                                </div>
                                <div class="col-xl-7 col-md-7 col-sm-12">
                                    <label for="">Endereço</label>
                                    <input type="text" class="form-control" placeholder="Ex: Av. Paulista"
                                        v-model="lead.street">
                                </div>
                                <div class="col-xl-2 col-md-2 col-sm-12">
                                    <label for="">Nº</label>
                                    <input type="text" class="form-control" placeholder="Ex: 100"
                                        v-model="lead.number_street">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <label for="">Complemento</label>
                                    <input type="text" class="form-control" placeholder="Ex: Próximo à...."
                                        v-model="lead.complement">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">Bairro</label>
                                    <input type="text" class="form-control" placeholder="Ex: Centro"
                                        v-model="lead.district">
                                </div>
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">Cidade</label>
                                    <input type="text" class="form-control" placeholder="Ex: São Paulo"
                                        v-model="lead.city">
                                </div>
                                <div class="col-xl-4 col-md-4 col-sm-12">
                                    <label for="">UF</label>
                                    <input type="text" class="form-control" placeholder="Ex: SP" v-model="lead.uf">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Vendedor(a)</label>
                                    <input type="text" class="form-control" placeholder="Ex: Maria"
                                        v-model="lead.seller">
                                </div>
                                <div class="col-xl-6 col-md-6 col-sm-12">
                                    <label for="">Valor médio retorno lead</label>
                                    <input type="text" class="form-control" placeholder="R$ 0,00"
                                        v-model.lazy="lead.amount" v-money="money">
                                </div>
                            </div>
                            <div class="row mt-2">
                                <div class="col-xl-7 col-md-7 col-sm-12">
                                    <label for="">Serviço</label>
                                    <multiselect v-model="service_multiselect" :options="services_options"
                                        :custom-label="serviceWithLang" placeholder="Selecione uma opção"
                                        :select-label="'Clique para selecionar'" :deselect-label="'Clique para remover'"
                                        @select="handleSelectService">
                                        <template #noResult>
                                            Nenhum serviço encontrado.
                                        </template>
                                    </multiselect>
                                </div>
                                <div class="col-xl-3 col-md-3 col-sm-12">
                                    <label for="">Valor</label>
                                    <input type="text" class="form-control" placeholder="R$ 0,00"
                                        v-model.lazy="lead.amount_service" v-money="money">
                                </div>
                                <div class="col-xl-2 col-md-2 col-sm-12">
                                    <br><button class="btn btn-success mt-2 btnFull" :disabled='!isDisabledService'
                                        @click="addListService"><i class="fa fa-plus"></i> Adicionar</button>
                                </div>
                            </div>
                            <div class="row mt-3" v-if="lead.services.length > 0">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <h6>Serviços adicionados</h6>
                                    <div class="table-responsive">
                                        <table class="table" id="dataTable" width="100%" cellspacing="0">
                                            <thead>
                                                <tr>
                                                    <th>#</th>
                                                    <th>Serviço</th>
                                                    <th>Valor</th>
                                                    <th></th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(service, index) in lead.services" :key="service.id">
                                                    <td>{{ ++index }} </td>
                                                    <td>{{ service.name }} </td>
                                                    <td>{{ service.price }} </td>
                                                    <td><button type="button" class="btn btn-danger"
                                                            @click="removeServiceList(service)"><i
                                                                class="fa fa-trash"></i> Remover</button></td>
                                                </tr>
                                                <tr>
                                                    <td colspan="4" class="text-left">Total em serviços: <strong> {{
                                                        total_service }}</strong></td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                            <div class="row mb-4 mt-3">
                                <div class="col-lg-12 col-xs-12 col-sm-12">
                                    <label for="">Observações</label>
                                    <editorText @update-text="updateObservation" :modelValue="lead.observation"
                                        placeholderSend="Sem observações" ref="myChild">
                                    </editorText>
                                </div>
                            </div>
                            <br><br>
                            <div class="row mt-3">
                                <div class="col-xl-12 col-md-12 col-sm-12">
                                    <button type="submit" :disabled='!isDisabled' class="btn btn-info"><i
                                            class="fa fa-save"></i> Cadastrar</button>
                                    <router-link to="/lead" class="btn btn-danger ml-3"><i class="fa fa-times"></i>
                                        Cancelar</router-link>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/api';
import { handleRequestErrors } from '@/handleErrors';
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/css/index.css';
import { mask } from 'vue-the-mask'
import editorText from '../util/editor-text.vue';
import { getCNPJ, getCNPJAlternative, loadZipcode } from '@/api-external';
import { VMoney } from 'v-money'
import Multiselect from 'vue-multiselect'
import { capitalize, maskPhone } from '@/util';


export default {
    directives: { mask, money: VMoney },
    components: { Loading, editorText, Multiselect },
    data() {
        return {
            isLoading: true,
            fullPage: true,
            results: [],
            services: {},
            service_multiselect: '',
            services_options: [],
            money: {
                decimal: ',',
                thousands: '.',
                prefix: 'R$ ',
                suffix: '',
                precision: 2,
                masked: false
            },
            lead: {
                document: '',
                name: '',
                email: '',
                phone: '',
                zipcode: '',
                street: '',
                number_street: '',
                complement: '',
                district: '',
                city: '',
                uf: '',
                seller: '',
                services: [],
                amount: '',
                id_service: '',
                name_service: '',
                amount_service: '',
                total_service: 0,
                observation: ''
            },
            enable_error_list: false,
            errors: []
        }
    },

    computed: {
        isDisabled: function () {
            return this.lead.name != '' && this.lead.phone != '';
        },
        isDisabledService: function () {
            return this.service_multiselect != '' && (this.lead.amount_service != '' && this.lead.amount_service != 'R$ 0,00');
        }
    },
    mounted() {
        this.isLoading = false;
        this.loadServices();

    },
    methods: {
        onCancel() { },
        formatReal(value) {
            return new Intl.NumberFormat('pt-BR', {
                style: 'currency',
                currency: 'BRL'
            }).format(value);
        },
        removeMaskReal(value) {
            let numbers = value.replace(/[^0-9,]/g, "");
            let result = parseFloat(numbers.replace(",", "."));
            return result;
        },
        loadServices() {
            this.service_multiselect = '';
            this.services_options = [];
            const response_services = this.getServices();
            response_services.then(() => {
                this.services_options = this.services.map(item => ({
                    key: item.id,
                    value: item.name,
                    price: item.amount
                }));
            });
        },
        serviceWithLang({ value }) {
            return value;
        },

        handleSelectService(option) {
            this.id_service = option.key;
            this.name_service = option.value;
            this.lead.amount_service = this.formatReal(option.price);
        },
        addListService() {
            const existServiceList = this.lead.services.some(service => service.id === this.id_service);
            if (!existServiceList) {
                this.lead.services.push({ 'id': this.id_service, 'name': this.name_service, 'price': this.lead.amount_service });
                this.calculateTotalServices();
            } else {
                this.$notify({
                    title: "Informação",
                    text: "Serviço já adicionado na lista",
                    type: 'info'
                });
            }
            this.service_multiselect = '';
            this.id_service = '';
            this.name_service = '';
            this.lead.amount_service = '';

        },
        removeServiceList(service_remove) {
            const updatedListService = this.lead.services.filter(service => service.id !== service_remove.id);
            this.lead.services = updatedListService;
            this.calculateTotalServices();
        },
        calculateTotalServices() {
            let sum = 0;
            this.lead.services.forEach(service => {
                const price = this.removeMaskReal(service.price);
                sum += parseFloat(price);
            });

            this.total_service = this.formatReal(sum);
        },
        searchZipcode() {

            if (this.lead.zipcode.length > 0) {
                this.isLoading = true;
                let zipcode = this.lead.zipcode.replace(/\D/g, '');
                loadZipcode(zipcode).then((response) => {
                    this.lead.street = response.street;
                    this.lead.district = response.neighborhood;
                    this.lead.city = response.city;
                    this.lead.uf = response.state;
                    this.isLoading = false;
                }).catch(() => {
                    this.isLoading = false;
                });
            } else {
                this.isLoading = true;
                this.$notify({
                    title: "Informação",
                    text: "Informe um CEP válido",
                    type: 'info'
                });
            }
        },
        updateObservation(observation) {
            this.lead.observation = observation;
        },
        save(event) {
            event.preventDefault();
            this.enable_error_list = false;
            this.isLoading = true;
            api.post('/lead', this.lead)
                .then(() => {
                    this.isLoading = false;
                    this.$notify({
                        title: "Sucesso",
                        text: "Lead cadastrado com sucesso!",
                        type: 'success'
                    });
                    this.lead = {};
                    this.lead.services = [];
                    this.lead.total_service = 0;
                }).catch(error => {
                    this.isLoading = false;
                    if (error.status == 422) {
                        let response_errors = error.response.data.errors;
                        this.errors = response_errors;
                        this.enable_error_list = true;
                    }
                    handleRequestErrors(error.status, error);
                })

        },
        searchService() {
            if (this.lead.service.length > 3) {
                this.enable_error_list = false;
                api.get('/search-service', { params: { 'search': this.lead.service } })
                    .then((response) => {
                        const result_response = response.data.search;
                        result_response.forEach(service => {
                            this.results.push({
                                'name': service.name,

                            })

                        });
                    }).catch(error => {
                        handleRequestErrors(error.status, error);
                    })
            }
        },
        selectedService(service_selected) {
            this.lead.service = this.lead.service + ' ' + service_selected;
            this.results = [];
        },

        async getServices() {
            const response = api.get('/serviceAll')
                .then((response) => {
                    this.isLoading = false;
                    this.services = response.data.services;

                }).catch(error => {
                    this.isLoading = false;
                    handleRequestErrors(error.status, error);
                });

            return response;
        },
        searchCNPJ() {
            if (this.lead.document.length > 0) {
                this.isLoading = true;
                let cnpj = this.lead.document.replace(/\D/g, '');
                if (cnpj.length == 14) {
                    getCNPJ(cnpj).then((response) => {
                        this.lead.name = capitalize(response.razao_social);
                        this.lead.email = response.email ? response.email : '';
                        this.lead.zipcode = response.cep ? capitalize(response.cep) : '';
                        this.lead.complement = response.complemento ? capitalize(response.complemento) : '';
                        this.lead.district = response.bairro ? capitalize(response.bairro) : '';
                        this.lead.city = response.municipio ? capitalize(response.municipio) : '';
                        this.lead.uf = response.uf ? response.uf : '';
                        this.isLoading = false;
                        if (this.lead.email == '') {
                            getCNPJAlternative(cnpj).then((response) => {
                                this.lead.street = capitalize(response.logradouro);
                                this.lead.email = response.email ? response.email.toLowerCase() : '';
                                this.lead.number_street = response.numero ? response.numero : '';
                                this.lead.name_fantasy = response.nome_fantasia ? capitalize(response.nome_fantasia) : '';
                                this.lead.phone = response.telefones ? maskPhone(response.telefones[0].ddd + response.telefones[0].numero) : '';
                                if (response.situacao_cadastral == 'Baixada') {
                                    this.$notify({
                                        title: "Informação",
                                        text: "O CNPJ em questão contra-se com status de baixada",
                                        type: 'info'
                                    });
                                }
                            }).catch(() => {
                                this.isLoading = false;
                            });
                        }
                    }).catch(() => {
                        this.isLoading = false;
                    });
                } else {
                    this.isLoading = false;
                    this.$notify({
                        title: "Informação",
                        text: "O CNPJ deve ter 14 dígitos",
                        type: 'info'
                    });
                }

            }
        }
    }
}
</script>

<style>
.autocomplete-list {
    position: absolute;
    list-style-type: none;
    background: #fff;
    width: 100%;
    margin-top: 50px;
    box-shadow: 0 0 10px #ddd;
    background: #e9e9e9;
    transition: all 300ms ease-out;
    transform: scale(1) translateY(0);
    transform-origin: center center;
    z-index: 99999;
    max-height: 300px;
    overflow-y: auto;
}

.list-item {
    padding: 10px;
    border-top: 1px solid #0000001f;
    background: #e9e9e9;
}

.list-item:hover {
    background: #d8d8d8;
}

.pointer {
    cursor: pointer;
}
</style>